// extracted by mini-css-extract-plugin
module.exports = {"WaterSpray":"WaterSpray_WaterSpray__3Nt4R","animate":"WaterSpray_animate__2gHj1"};